import React, { useEffect, useState } from "react";
import { useForm } from "react-hook-form";
import { useNavigate } from "react-router-dom";
import productService from "../../services/product-service";
import { Divider } from "antd";

const AdminProducts = () => {
  let navigate = useNavigate();
  const [list, setList] = useState([]);
  const [showEdit, setShowEdit] = useState(false);
  const [showSave, setShowSave] = useState(true);

  const measurementList = [
    { id: 1, name: "GRAMOS" },
    { id: 2, name: "MILILITROS" },
  ];

  const {
    register,
    handleSubmit,
    setValue,
    getValues,
    reset,
    formState: { errors },
  } = useForm();

  useEffect(() => {
    getListProducts();
  }, []);

  const toUpperFieldName = (e) => {
    let value = e.target.value;
    setValue("name", value.toUpperCase());
  };

 
  ////FUNCIONES QUE USAN EL SERVICIO FARMSERVICE
  ////FUNCIONES QUE USAN EL SERVICIO FARMSERVICE
  const getListProducts = async () => {
    const listado = await productService.getList();
    if(listado)
      setList(listado);
  };

  const updateProduct = async () => {
    const id = getValues("id");
    const name = getValues("name");
    const measurement = getValues("measurement");
    const data = {name, measurement, id };
    const success = await productService.update(data);
    if (success) {
      reset();
      getListProducts();
      setShowEdit(false);
      setShowSave(true);
    }
  };

  const customSubmit = async (data) => {
    const success = await productService.insert(data);
    if (success) {
      reset();
      getListProducts();
    }
  };

  const cancelar = async () => {
    setShowEdit(false);
    setShowSave(true);
    reset();
  };

  const getProduct = async (productId) => {
    const product = await productService.getProduct(productId);
    if (product) {
      setValue("id", product._id);
      setValue("name", product.name);
      setValue("state", product.state);
      setShowEdit(true);
      setShowSave(false);
    }
  };

  return (      
    <div className="row p-4">
    <div className="col-12 " style={{marginTop:"-10px"}}>
        <Divider orientation="left" style={{ border: "#AAAAAA" }} >Gestión de productos</Divider>
      </div>

      <div className="col-12 col-sm-4">
      <div className="card p-4">
        <form className="form-react" onSubmit={handleSubmit(customSubmit)}>
          <div className="row">
            <div className="card-title">              
            <h4 className="text-secondary" >Datos del producto</h4>
            </div>

            <div className=" col-12 d-none">
              <label>Id finca</label>
              <input
                readOnly={true}
                type="text"
                className="form-control bg-light"
                {...register("id")}
              />
            </div>

            <div className=" col-12">
              <label>Nombre</label>
              <input
                type="text"
                onKeyUp={toUpperFieldName}
                className="form-control"
                {...register("name", { required: true, minLength: 3 })}
              />
              {errors.name?.type === "required" && (
                <small className="text-danger">Campo requerido</small>
              )}
              {errors.name?.type === "minLength" && (
                <small className="text-danger">Minimo 10 caracteres</small>
              )}
            </div>

            <div className=" col-12">
              <label>Unidad de medida</label>
              <select className="form-control" {...register("measurement")}>
                {measurementList.map((option) => (
                  <option key={option.id} value={option.id}>
                    {option.name}
                  </option>
                ))}
              </select>
            </div>

            <div className={showEdit ? " col-6" : "d-none"}>
              <label>&nbsp; </label>
              <button
                className="btn btn-primary w-100"
                type="button"
                onClick={() => updateProduct()}
              >
                <i className="bi bi-save fa-lg" /> Editar
              </button>
            </div>

            <div className={showSave ? " col-6" : "d-none"}>
              <label>&nbsp; </label>
              <button className="btn btn-primary w-100" type="submit">
              <i className="bi bi-save fa-lg m-2" /> Guardar
              </button>
            </div>

            <div className=" col-6">
              <label>&nbsp; </label>
              <button
                className="btn btn-secondary w-100"
                type="button"
                onClick={() => cancelar()}
              >
                <i className="bi bi-x-square fa-lg m-2" /> Cancelar
              </button>
            </div>
          </div>
        </form>
      </div>

      </div>

      <div className="col-12 col-sm-4">
      <div className="card p-4">
        <div className="card-title ms-2">          
        <h4 className="text-secondary" >Listado de productos</h4>
          <div className=" bdr">
            <table className="table ">
              <thead className="table-primary">
                <tr>
                  <th>Nombre</th>
                  <th></th>
                </tr>
              </thead>
              <tbody>
                {list.map((product) => (
                  <tr key={product._id}>
                    <td>{product.name}</td>
                    <td style={{ width: "120px" }}>
                      <button
                        className="btn btn-primary"
                        onClick={() => getProduct(product._id)}
                      >
                        <i className="bi bi-pencil-square fa-lg m-1" /> Editar
                      </button>

                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </div>
      </div>
      </div>


    </div>
  );
};

export default AdminProducts;
